import React from 'react';
import PropTypes from 'prop-types';
import { WIDGET_GRID_COPY } from '../../constants';

/**
 * @param {object} props
 * @param {object} [props.data]
 * @param {string} [props.emptyMessage] What the card reads when the widget has
 *   no items. Defaults to the package's English copy; an app with i18n passes
 *   its own, which is how a Spanish session stops reading "No data to
 *   display." (CT-5885). `WidgetWrapper` threads it from the grid's
 *   `stateCopy`.
 */
const Widget = ({ data = null, emptyMessage = WIDGET_GRID_COPY.states.noData }) => {
  if (!data) return null;

  const title = data.title || 'Widget';
  const items = data.items || [];

  return (
    <div className="h-full text-base text-content-secondary">
      <h3 className="mt-0 mb-3 text-lg font-medium text-content">{title}</h3>
      {items.length > 0 ? (
        <ul className="m-0 p-0 list-none">
          {items.slice(0, 5).map((item) => (
            <li
              key={item.id || JSON.stringify(item)}
              className="py-2 border-b border-edge last:border-b-0"
            >
              {item.content || item.subject || item.description || '-'}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-content-muted">{emptyMessage}</p>
      )}
    </div>
  );
};

Widget.propTypes = {
  data: PropTypes.object,
  emptyMessage: PropTypes.string,
};


export default Widget;
